export default {
  getNomenclature: state => state.items,
}
